import { render, staticRenderFns } from "./golf.vue?vue&type=template&id=7281c6d0&scoped=true&"
import script from "./golf.vue?vue&type=script&lang=js&"
export * from "./golf.vue?vue&type=script&lang=js&"
import style0 from "./golf.vue?vue&type=style&index=0&id=7281c6d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7281c6d0",
  null
  
)

export default component.exports